module.exports = __webpack_public_path__ + "static/image1-2e6f2b8eaca469907df763f0b2ccaa7d.png";